import { useTranslation } from 'react-i18next';
import { cn } from '../../../utils/cn';
import type { NurseryLoadStatus } from '../../../types/nursery';

const STYLES: Record<NurseryLoadStatus, string> = {
  planning:   'bg-neutral-100 text-neutral-700',
  released:   'bg-blue-100 text-blue-700',
  picking:    'bg-yellow-100 text-yellow-800',
  loaded:     'bg-teal-100 text-teal-700',
  despatched: 'bg-green-100 text-green-700',
  cancelled:  'bg-red-100 text-red-700',
};

export function LoadStatusBadge({ status, className }: { status: NurseryLoadStatus; className?: string }) {
  const { t } = useTranslation('nursery', { keyPrefix: 'LoadStatusBadge' });
  return (
    <span className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold whitespace-nowrap', STYLES[status], className)}>
      {t(`status.${status}`)}
    </span>
  );
}

export default LoadStatusBadge;
